const pageNameKey = "machinesRemoteSupportActiveButton";

export const machinesRemoteSupportActiveButtonEn = {
  [pageNameKey]: {
    activeSession: "Active session",
    vncSettingsTitle: "VNC settings",
    optionsTitle: "Options",
    activeStatus: "Active",
    enterScreensharing: "Enter Screensharing",
    disconnect: "Disconnect",
    disconnecting: "Disconnecting...",
    vncOptions: "VNC Options",
    swapRBLabel: "Swap the red and blue colors",
    swapRBTooltip:
      "Turn on if orange looks blue or red and blue appear reversed.",
    vncVersionLabel: "noVNC version",
    continueButton: "Continue",
    cancelButton: "Cancel",
    closeButton: "Close",
    redirect: "redirect",
    activeOtherUser: "Active (Other user)",
    awaitingTechnicianTooltip:
      "The session is waiting to start.\nYou'll be able to join once the technician begins screen sharing.",
    activeOtherUserTooltip:
      "The session is approved and waiting to start.\nYou'll be able to join once the technician begins screen sharing.",
    privateActiveOtherUserTooltip:
      "This is a private session. Only the technician who requested it can connect.",
  },
};

export const machinesRemoteSupportActiveButtonPtBr = {
  [pageNameKey]: {
    activeSession: "Sessão ativa",
    vncSettingsTitle: "Configurações do VNC",
    optionsTitle: "Opções",
    activeStatus: "Ativa",
    enterScreensharing: "Entrar no compartilhamento de tela",
    disconnect: "Desconectar",
    disconnecting: "Desconectando...",
    vncOptions: "Opções de VNC",
    swapRBLabel: "Trocar as cores vermelha e azul",
    swapRBTooltip:
      "Ative se o laranja parecer azul ou se o vermelho e o azul parecerem invertidos.",
    vncVersionLabel: "Versão do noVNC",
    continueButton: "Continuar",
    cancelButton: "Cancelar",
    closeButton: "Fechar",
    redirect: "redirecionar",
    activeOtherUser: "Ativa (outro usuário)",
    awaitingTechnicianTooltip:
      "A sessão está aguardando para iniciar.\nVocê poderá entrar quando o técnico começar o compartilhamento de tela.",
    activeOtherUserTooltip:
      "A sessão foi aprovada e está aguardando para iniciar.\nVocê poderá entrar quando o técnico começar o compartilhamento de tela.",
    privateActiveOtherUserTooltip:
      "Esta é uma sessão privada. Somente o técnico que a solicitou pode se conectar.",
  },
};

export const machinesRemoteSupportActiveButtonDe = {
  [pageNameKey]: {
    activeSession: "Aktive Sitzung",
    vncSettingsTitle: "VNC-Einstellungen",
    optionsTitle: "Optionen",
    activeStatus: "Aktiv",
    enterScreensharing: "Bildschirmfreigabe starten",
    disconnect: "Trennen",
    disconnecting: "Trennen...",
    vncOptions: "VNC-Optionen",
    swapRBLabel: "Rote und blaue Farben tauschen",
    swapRBTooltip:
      "Aktivieren Sie diese Option, wenn Orange blau aussieht oder Rot und Blau vertauscht erscheinen.",
    vncVersionLabel: "noVNC-Version",
    continueButton: "Weiter",
    cancelButton: "Abbrechen",
    closeButton: "Schließen",
    redirect: "Weiterleiten",
    activeOtherUser: "Aktiv (anderer Benutzer)",
    awaitingTechnicianTooltip:
      "Die Sitzung wartet auf den Start.\nSie können beitreten, sobald der Techniker mit der Bildschirmfreigabe beginnt.",
    activeOtherUserTooltip:
      "Die Sitzung ist genehmigt und wartet auf den Start.\nSie können beitreten, sobald der Techniker mit der Bildschirmfreigabe beginnt.",
    privateActiveOtherUserTooltip:
      "Dies ist eine private Sitzung. Nur der Techniker, der sie angefordert hat, kann sich verbinden.",
  },
};

export const machinesRemoteSupportActiveButtonZhHans = {
  [pageNameKey]: {
    activeSession: "活动会话",
    vncSettingsTitle: "VNC 设置",
    optionsTitle: "选项",
    activeStatus: "活动",
    enterScreensharing: "进入屏幕共享",
    disconnect: "断开连接",
    disconnecting: "正在断开连接...",
    vncOptions: "VNC 选项",
    swapRBLabel: "互换红蓝两色",
    swapRBTooltip: "如果橙色看起来像蓝色，或红色和蓝色显示颠倒，请开启此选项。",
    vncVersionLabel: "noVNC 版本",
    continueButton: "继续",
    cancelButton: "取消",
    closeButton: "关闭",
    redirect: "重定向",
    activeOtherUser: "活动（其他用户）",
    awaitingTechnicianTooltip:
      "会话正在等待开始。\n技术人员开始共享屏幕后，您将可以加入。",
    activeOtherUserTooltip:
      "该会话已获批准，正在等待开始。\n技术人员开始共享屏幕后，您将可以加入。",
    privateActiveOtherUserTooltip:
      "这是一个私有会话。只有发起请求的技术人员可以连接。",
  },
};

export const machinesRemoteSupportActiveButtonIt = {
  [pageNameKey]: {
    activeSession: "Sessione attiva",
    vncSettingsTitle: "Impostazioni VNC",
    optionsTitle: "Opzioni",
    activeStatus: "Attiva",
    enterScreensharing: "Avvia condivisione schermo",
    disconnect: "Disconnetti",
    disconnecting: "Disconnessione...",
    vncOptions: "Opzioni VNC",
    swapRBLabel: "Scambia i colori rosso e blu",
    swapRBTooltip:
      "Attiva se l’arancione appare blu oppure se il rosso e il blu sembrano invertiti.",
    vncVersionLabel: "Versione noVNC",
    continueButton: "Continua",
    cancelButton: "Annulla",
    closeButton: "Chiudi",
    redirect: "reindirizza",
    activeOtherUser: "Attiva (altro utente)",
    awaitingTechnicianTooltip:
      "La sessione è in attesa di iniziare.\nPotrai unirti quando il tecnico inizierà la condivisione dello schermo.",
    activeOtherUserTooltip:
      "La sessione è approvata e in attesa di iniziare.\nPotrai unirti quando il tecnico avvierà la condivisione dello schermo.",
    privateActiveOtherUserTooltip:
      "Questa è una sessione privata. Solo il tecnico che l'ha richiesta può connettersi.",
  },
};

export const machinesRemoteSupportActiveButtonEs = {
  [pageNameKey]: {
    activeSession: "Sesión activa",
    vncSettingsTitle: "Configuración de VNC",
    optionsTitle: "Opciones",
    activeStatus: "Activa",
    enterScreensharing: "Entrar a compartir pantalla",
    disconnect: "Desconectar",
    disconnecting: "Desconectando...",
    vncOptions: "Opciones de VNC",
    swapRBLabel: "Intercambiar los colores rojo y azul",
    swapRBTooltip:
      "Actívalo si el naranja parece azul o si el rojo y el azul aparecen invertidos.",
    vncVersionLabel: "Versión de noVNC",
    continueButton: "Continuar",
    cancelButton: "Cancelar",
    closeButton: "Cerrar",
    redirect: "redirigir",
    activeOtherUser: "Activa (otro usuario)",
    awaitingTechnicianTooltip:
      "La sesión está esperando para comenzar.\nPodrá unirse cuando el técnico inicie el uso compartido de pantalla.",
    activeOtherUserTooltip:
      "La sesión está aprobada y esperando para comenzar.\nPodrá unirse cuando el técnico inicie el uso compartido de pantalla.",
    privateActiveOtherUserTooltip:
      "Esta es una sesión privada. Solo el técnico que la solicitó puede conectarse.",
  },
};

export const machinesRemoteSupportActiveButtonNl = {
  [pageNameKey]: {
    activeSession: "Actieve sessie",
    vncSettingsTitle: "VNC-instellingen",
    optionsTitle: "Opties",
    activeStatus: "Actief",
    enterScreensharing: "Schermdeling starten",
    disconnect: "Verbinding verbreken",
    disconnecting: "Verbinding verbreken...",
    vncOptions: "VNC-opties",
    swapRBLabel: "De rode en blauwe kleuren omwisselen",
    swapRBTooltip:
      "Schakel dit in als oranje er blauw uitziet of rood en blauw omgewisseld lijken.",
    vncVersionLabel: "noVNC-versie",
    continueButton: "Doorgaan",
    cancelButton: "Annuleren",
    closeButton: "Sluiten",
    redirect: "Doorsturen",
    activeOtherUser: "Actief (andere gebruiker)",
    awaitingTechnicianTooltip:
      "De sessie wacht om te starten.\nU kunt deelnemen zodra de technicus het scherm begint te delen.",
    activeOtherUserTooltip:
      "De sessie is goedgekeurd en wacht om te starten.\nU kunt deelnemen zodra de technicus het scherm begint te delen.",
    privateActiveOtherUserTooltip:
      "Dit is een privésessie. Alleen de technicus die de sessie heeft aangevraagd kan verbinding maken.",
  },
};

export const machinesRemoteSupportActiveButtonTr = {
  [pageNameKey]: {
    activeOtherUser: "Aktif (Diğer kullanıcı)",
    activeOtherUserTooltip:
      "Oturum onaylandı ve başlamayı bekliyor.\\nTeknisyen ekran paylaşımına başladığında oturuma katılabileceksiniz.",
    activeSession: "Aktif oturum",
    awaitingTechnicianTooltip:
      "Oturumun başlaması bekleniyor.\\nTeknisyen ekran paylaşımına başladığında oturuma katılabileceksiniz.",
    privateActiveOtherUserTooltip:
      "Bu özel bir oturumdur. Yalnızca talep eden teknisyen bağlanabilir.",
    redirect: "yönlendirmek",
    swapRBLabel: "Kırmızı ve mavi renkleri değiştirin",
    swapRBTooltip:
      "Turuncu mavi veya kırmızı görünüyorsa ve mavi ters görünüyorsa açın.",
    vncSettingsTitle: "VNC ayarları",
    optionsTitle: "Seçenekler",
    activeStatus: "Aktif",
    enterScreensharing: "Ekran paylaşımına gir",
    disconnect: "Bağlantıyı kes",
    disconnecting: "Bağlantı kesiliyor...",
    vncOptions: "VNC seçenekleri",
    vncVersionLabel: "noVNC sürümü",
    continueButton: "Devam",
    cancelButton: "İptal",
    closeButton: "Kapat",
  },
};
